import React, { Suspense } from 'react';

import type { DebugOverridesPanelProps } from './index';

const DebugOverridesPanelLazy = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/search-page/debug-overrides-panel" */ './index'
	).then(({ DebugOverridesPanel }) => ({ default: DebugOverridesPanel })),
);

export const DebugOverridesPanel = (props: DebugOverridesPanelProps) => (
	<Suspense fallback={null}>
		<DebugOverridesPanelLazy {...props} />
	</Suspense>
);
